let menucontainer = $('.menu-actions');

function toggleOverlayMenu() {
  if(menucontainer.attr('data-menu') === 'closed'){
    menucontainer.attr('data-menu', 'opened');
  }
  else {
    menucontainer.attr('data-menu', 'closed');
  }
    $('body,html').toggleClass('mobile-menu-is-open');

    setTimeout(() => {
      $('.child-link-container-main').removeClass('opened');
      $('.back-btn-mobile-menu').removeClass('submenu-active');
    }, 200);
}

$('.menu-open-close').click(function() {
  toggleOverlayMenu();
});

$('.mobile-menu-shade').click(function() {
  toggleOverlayMenu()
});

$('[data-back]').click(function() {
  $('.child-link-container-main').removeClass('opened');
  $('.back-btn-mobile-menu').removeClass('submenu-active');
});

$('.toggle-sublinks').click(function(e) {
  let sublinkcontainer = $(this).next();
  $(this).addClass('sublinks-open');
  $(this).next().addClass('opened');
  $('.back-btn-mobile-menu').addClass('submenu-active');
});

$('[data-cart-toggle]').click(function(event){
  event.preventDefault();
  toggleOverlayMenu();
  setTimeout(() => {
    document.dispatchEvent(new CustomEvent('cart:open'));  
  }, 200);
});

// Fix Nav on Scroll
let siteHeader = $('#shopify-section-header');
$(window).scroll(function(e){
    if($(document).scrollTop() > 110) {
      siteHeader.addClass('fixed-nav');
    }
    else {
      siteHeader.removeClass('fixed-nav');
    }
});